import set from 'lodash/set';
import { identify } from './v4.calls';
import { convert } from './v4';
import psProperties from './v4.ps-properties';
import { getNowISO } from './helper';

const conversionProperties = ['email', 'phone'];

const visitorProperties = {
    [psProperties.firstSeenAt]: getNowISO(),
};

// that object is dynamic, it holds one or more question / form information
export const updateVisitorProperties = (obj: { [key: string]: any }) => {
    Object.keys(obj).forEach((key) => {
        set(visitorProperties, key, obj[key]);
    });

    conversionProperties.forEach((conversionProperty) => {
        if (visitorProperties[conversionProperty] && !visitorProperties[psProperties.isConverted]) {
            set(visitorProperties, psProperties.isConverted, true);
            set(visitorProperties, psProperties.convertedAt, getNowISO());
            convert();
        }
    });
    set(visitorProperties, psProperties.lastSeenAt, getNowISO());

    identify(visitorProperties);
};
export const getVisitorProperties = () => visitorProperties;
